import { NgModule } from '@angular/core';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule, TranslateLoader, TranslateService, TranslatePipe } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { HttpJsonUtilities } from './http/http-json-utilities.service';
import { ActivityService } from './activity/activity.service';
import { HttpConfigService } from './http/http-config.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './services/auth.interceptor';

import { AccountClient, API_BASE_URL, ClientClient, UserAccountClient } from './models/models.swagger.generated';

import { AppErrorMessagesService } from './services/app-error-messages.service';
import { EnumTranslationService } from './services/enum-translation.service';

import { environment } from '../../environments/environment';

import { SpinnerService } from './spinner/spinner.service';
import { LoginProxy } from './http/login-proxy.service';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { VersionService } from './services/version/version.service';

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, '../../assets/i18n/', '.json');
}

export function tokenGetter() {
  return localStorage.getItem(environment.localStorageToken);
}

@NgModule({
  declarations: [],
  bootstrap: [],
  exports: [],
  imports: [
    TranslateModule.forRoot({
          loader: {
              provide: TranslateLoader,
              useFactory: HttpLoaderFactory,
              deps: [HttpClient]
          }
      }),
      FontAwesomeModule,
      /* AgmCoreModule.forRoot({
        apiKey: environment.googleMapsApisKey
      }), */
      NgIdleKeepaliveModule.forRoot(),
      BrowserAnimationsModule,
      
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: API_BASE_URL, useValue: environment.apiServerUrl },
    HttpClient,
    HttpJsonUtilities,
    HttpConfigService,
    SpinnerService,
    TranslateService,
    TranslatePipe,
    ActivityService,
    LoginProxy,
    AppErrorMessagesService,
    EnumTranslationService,
    /* swagger clients */
    AccountClient,
    UserAccountClient,
    ClientClient,
    VersionService,
    
    provideHttpClient(withInterceptorsFromDi()),
  ] })
export class BaseModule { }
